import React, { Component } from 'react';

import Card from '../card';
import ControlBar from '../control-bar';
import ProgressBar from '../progress-bar';
import Welcom from '../welcom';
import Final from '../final';

import cardsData from '../cards.json';
import './deck.scss';

export default class Deck extends Component {
    state = {
        isGameStarted: false,
        isFlipped: false,
        step: 0,
        cardsData: Object.assign({}, cardsData)
    }

    startApp = () => this.setState({ isGameStarted: true });
    restartApp = () => this.setState({ step: 0 });
    nextStep = () => {
        this.setState({
            step: this.state.step + 1,
            isFlipped: false
        });
    }

    getCardsData() {
        const cardData = cardsData[this.state.step];
        if (cardData) {
            const { id, title, theme, questions } = cardData;
            return {
                cardId: id,
                cardTitle: title,
                cardTheme: theme,
                cardQuestions: questions
            }
        }
        return
    }

    flipCard = () => {
        this.setState({ isFlipped: true });
    }

    getCardComponent = (cardData) => {
        const { isFlipped, isGameStarted } = this.state;
        return (
            <React.Fragment>
                <ProgressBar isGameStarted={isGameStarted} cardId={cardData.cardId} />
                <Card
                    isFlipped={isFlipped}
                    flipCard={this.flipCard}
                    in={true}
                    step={this.nextStep}
                    cardData={cardData}
                />
                {this.includeControlBar(cardData)}
            </React.Fragment>
        )
    }

    getDeckBody(cardData) {
        if (!cardData) {
            return (
                <React.Fragment>
                    <Final isGameStarted={this.state.isGameStarted} />
                    {this.includeControlBar(cardData)}
                </React.Fragment>
            )
        } else {
            return this.getCardComponent(cardData)
        }
    }

    includeControlBar = (cardData) => {
        const cardId = cardData ? cardData.cardId : null;
        return (
            <ControlBar
                cardId={cardId}
                isFlipped={this.state.isFlipped}
                nextCard={this.nextStep}
                flipCard={this.flipCard}
                contactUsUrl={this.props.contactUsUrl}
                restartApp={this.restartApp}
                lastCardId={cardsData.length}
                isGameStarted={this.state.isGameStarted}
                step={this.state.step}
            />
        )
    }

    render() {
        const cardData = this.getCardsData();

        const deckBody = this.state.isGameStarted ? this.getDeckBody(cardData) : <Welcom in={this.state.isGameStarted} onClick={this.startApp} />;
        return (
            <div className="deck">
                {deckBody}
            </div>
        )
    }
}
